import { CanActivateFn, Router } from "@angular/router";
import { MLoginNavigationService } from './mlogin-navigation.service';
import { inject } from "@angular/core";

export const mloginRedirectGuard: CanActivateFn = () => {
  const mLoginNavigationService = inject(MLoginNavigationService);
  const router = inject(Router);
  const doneRedirectUri = mLoginNavigationService.loadDoneRedirectUriFromQueryParams();

  if (doneRedirectUri) {
    router.navigateByUrl(doneRedirectUri, {
      replaceUrl: true,
    });
  } else {
    // fallback in case the doneRedirectUri is not available, e.g. due to session storage being cleared
    router.navigateByUrl('/', {
      replaceUrl: true,
    });
  }
  return false;
}
